<template>
  <div 
    class="main" 
    style="position: absolute"
  >
  <Header :background="true" />
  <Welcome :layout="layout" />
  <div class="flex-column flex-grid--full">
    <div class="wrapper">
      <div class="text-center wrapper">
        <h2>iSalu</h2>
        <h3 class="text-tertiary">Je startpunt op de woningmarkt</h3>
      </div>
      <Step
        :StepAsLink=true
        StepSummary="verkopen"
        StepTitle="Zorg voor de juiste informatie"
        StepDetail="
          Voor het verkopen van een woning wordt de lokale makelaar makkelijk gevonden, maar er zijn ook andere opties.
          Welke opties zijn er en wanneer kies je voor welke optie. Met iSalu gaan we ons best doen jou de juiste keuzes te laten maken.
          "
      />
      <Step
        :StepAsLink=true
        StepSummary="kopen"
        StepTitle="Wat is mijn verkoop strategie?"
        StepDetail="
          Het grootste deel van de Nederlanders koopt een woning zelf aan. Best spannend, maar er is hulp!
          Vind de juiste kennis en kies de juiste tools, want alleen dan sta je sterk. Met iSalu willen we jou gaan helpen met het maken van de juiste keuzes. 
          "
      />
      <Step
        :StepAsLink=true
        StepSummary="huren"
        StepTitle="Hoe krijg ik een voet tussen de deur?"
        StepDetail="
          Het vinden van de juiste huurwoning wordt steeds lastiger. Je kunt niet meer zonder de juiste signalen op het juiste moment.
          Maar ook een makelaar kan je hier van dienst zijn. Met iSalu helpen we je op weg naar je nieuwe (t)huis. 
          "
      />
      <Step
        :StepAsLink=true
        StepSummary="verhuren"
        StepTitle="Wat besteed je uit?"
        StepDetail="
          Bij het verhuren van een woning is het belangrijkste dat je je bewust bent van het werk wat hier bij komt kijken. Alles uitbesteden, 
          of meer zelf doen en meer over houden? Met iSalu kan je deze keuze maken. 
          "
      />
      <Step
        :StepAsLink=true
        StepSummary="verbouwen"
        StepTitle="Waar vind de juiste mensen?"
        StepDetail="
          Of je nu een woning koopt, huur of verhuurt, onderhoud blijft altijd een belangrijk onderwerp. Tegenwoordig lijkt het vinden van de 
          juiste expertise moeilijker dan de klus zelf. Met iSalu vind je de expertise die je nodig hebt.
          "
      />
      <div class="text-center">
        <router-link 
            :to="{ name: 'Over ons' }" 
            class="btn btn-blue"
          >
            MEER OVER ISALU
        </router-link>
      </div>
    </div>
    <div class="wrapper bg--grey">
      <div class="text-center">
        <h2>Op zoek naar (ver)huren</h2>
        <div class="text-center">
          <a class="text-center btn btn-orange l-mt-3" href="https://tc.tradetracker.net/?c=25727&amp;m=1128957&amp;a=480276&amp;r=&amp;u=" target="_blank" rel="sponsored nofollow"> Huurwoningmarktplaats </a>
        </div>
      </div>
    </div>
    <div id="kopen" class="wrapper">
      <div class="text-center wrapper">
        <h2 class="text-center">Zelfverzekerd op de woningmarkt</h2>
        <h3 class="text-tertiary">Jouw droomhuis - onze kennis - onze partners</h3>
      </div>
      <Step
        StepSummary="de iSalu manier"
        StepTitle="Het is spannend genoeg"
        StepDetail="
          Je bewegen op de woningmarkt is spannend. Met iSalu willen we jou met de juiste kennis en mogelijkheden deze 'markt' op sturen. 
          We zijn druk bezig al onze kennis bij elkaar te brengen en jou toegang te geven tot interessante partners. 
          Stap voor stap willen we zo iedereen zelfverzekerd de woningmarkt op helpen.
          "
      />
      <Step
        StepSummary="Direct contact"
        StepTitle="Duidelijke regels"
        StepDetail="
          Onze ambitie is jou met de juiste informatie in contact te brengen met de juiste partners.
          Jij behoudt de regie. Geen verplichtigingen richting iSalu en altijd direct contact met onze partners. 
          Alle informatie is zonder kosten beschikbaar en jij kiest of en met welke partner jij in zee wenst te gaan.
          "
      />
    </div>
  </div>
  <Footer />
  </div>
</template>
<script>
import Header from "@/components/ComponentHeader";
import Welcome from "@/components/Welcome";
import Footer from "@/components/ComponentFooter";
import Step from "@/components/ComponentStep";

export default {
  name: "Homepage",
  components: {
    Header,
    Welcome,
    Footer,
    Step
  },
  props: {
    layout: {
      required: true,
      type: Object
    }
  }
};
</script>

<style scoped>
h2 {
  font-size: 44px;
  font-weight: 300;
  text-transform: uppercase;
}
h3 {
  font-size: 26px;
  font-weight: 300;
  text-transform: uppercase;
  margin-bottom: 32px;
}
h4 {
  font-weight: bold;
}
.wrapper {
  padding: 64px 0;
}
@media (min-width: 240px) and (max-width: 720px) {
  h2 {
    font-size: 36px;
    margin-bottom: 32px;
  }
  h3 {
    font-size: 20px;
  }
  .wrapper {
    padding-bottom: 32px;
  }
}
</style>
